export default __webpack_public_path__ + "static/media/monitor-white-icon.c365f249.png";